/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { AddUserModalComponent } from 'src/app/admin/components/modals/add-user-modal/add-user-modal.component';
import { DeleteUserModalComponent } from 'src/app/admin/components/modals/delete-user-modal/delete-user-modal.component';
import { EditUserModalComponent } from 'src/app/admin/components/modals/edit-user-modal/edit-user-modal.component';
import { PlayroomService } from 'src/app/admin/services/playroom.service';
import { UserService } from 'src/app/admin/services/user.service';

import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-manage-users-page',
  templateUrl: './manage-users.page.html',
  styleUrls: ['./manage-users.page.scss'],
})

export class ManageUsersPage implements OnInit {
  users: User[];
  users$ = this.userService.allUsers$;
  paginationSettings = {totalItems: 0};
  managers = [];
  currentPage: number = 1;
  itemsPerPage: number = 20;
  usernameQuery: string = '';
  firstNameQuery: string = '';
  lastNameQuery: string = '';
  idCardNoQuery: string = '';

  constructor(private userService: UserService, private modalController: ModalController, private roomService: PlayroomService
     ) {}

  ngOnInit(): void {
    this.userService.getAllUsers({currentPage: this.currentPage, itemsPerPage: this.itemsPerPage, usernameQuery: this.usernameQuery,
      firstNameQuery: this.firstNameQuery, lastNameQuery: this.lastNameQuery, idCardNoQuery: this.idCardNoQuery});
    this.userService.paginationSettings$.subscribe(pagSettings => {
      this.paginationSettings = pagSettings;
    });
    this.userService.allUsers$.subscribe(allUsers => { //TODO: dobaviti menadzere preko apija
      this.managers = allUsers.filter(e => e.role === 'Manager');
    });
  }

  async openAddUserModal() {
    const modal = await this.modalController.create({
      component: AddUserModalComponent,
      componentProps: {managers: this.managers},
      cssClass: 'basic-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });

    await modal.present();
  }

  async openDeleteUserModal(user) {
    const modal = await this.modalController.create({
      component: DeleteUserModalComponent,
      componentProps: {user},
      cssClass: 'small-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });
    await modal.present();
  }

  async openEditUserModal(user) {
   console.log(user,"user")
   
    const modal = await this.modalController.create({
      component: EditUserModalComponent,
      componentProps: {user: {...user}, managers: this.managers},
      cssClass: 'tall-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });
    await modal.present();
  }

  changePage(pageNumber) {
    this.currentPage = pageNumber;
    this.userService.getAllUsers({currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
       usernameQuery: this.usernameQuery, firstNameQuery: this.firstNameQuery, lastNameQuery: this.lastNameQuery,
       idCardNoQuery: this.idCardNoQuery});
  }

  async loadSearchResult(){
    this.userService.getAllUsers({currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      usernameQuery: this.usernameQuery, firstNameQuery: this.firstNameQuery, lastNameQuery: this.lastNameQuery,
      idCardNoQuery: this.idCardNoQuery});
  }


 resetFilters()
  {
    this.userService.getAllUsers();
    this.usernameQuery = '';
    this.firstNameQuery = '';
    this.lastNameQuery = '';
    this.idCardNoQuery = '';
  }
}
